export default "__VITE_ASSET__qS0v5wjk__"